import { combineReducers } from 'redux';

// reducer import
import userReducer from './user/userReducer';
import paymentSummeryReducer from './paymentSummery/paymentSummeryReducer';
import emailReducer from './emails/emailReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    user: userReducer,
    paymentSummery: paymentSummeryReducer,
    email: emailReducer
});

export default reducer;
